import { SettingsMenu } from "common/MapV2/controls/SettingsMenu";
import { OrderedMap } from "immutable";
import { setPreference } from "lib/api/currentUser";
import { commonUnits, useFormatMessage } from "lib/localization";
import { getPreferences } from "lib/utils";
import _ from "lodash";
import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import styles from "./Settings.scss";

const R = window.Routes;

const prefs = getPreferences();
const mapSettingsDefaults = {
  metricUnits: ["metric_units", false, "metric_units"],
  showCueIcons: ["show_coursepoint_icons", false, "show_coursepoint_icons"],
  autoCenter: ["route_viewer_auto_center", true, "auto_center"],
  scrollWheelZoom: ["route_viewer_enable_scrollwheel_zoom", true, "enable_scrollwheel_zoom"],
  showDistanceMarkers: ["route_viewer_enable_distance_markers", true, "show_distance_markers"],
  showPOIs: ["route_viewer_show_pois", true, "show_pois"],
  showTrackSurface: ["route_viewer_show_surface", true, "show_surface"],
  generateCues: ["route_viewer_generate_cues", true, "generate_cues"],
};
export const initialMapSettings = _.mapValues(mapSettingsDefaults, (x) => prefs[x[0]] ?? x[1]);

export const Settings = ({ mapSettings, dispatch, setMapSettings }) => {
  const intl = useIntl();
  const fm = useFormatMessage();

  const settingHandlers = {};
  Object.entries(mapSettingsDefaults).forEach(([settingKey, [prefKey, , mapKey]]) => {
    settingHandlers[`on${settingKey.charAt(0).toUpperCase()}${settingKey.slice(1)}Change`] = (value) => {
      R.activeMap.setOption(mapKey, value);
      dispatch(setMapSettings(Object.assign({}, mapSettings, { [settingKey]: value })));
      if (settingKey === "metricUnits") {
        window.rwgps.LabelMaker.metric = value;
        window.rwgps.Events.trigger("units_change");
        R.activeMap.activeRoute.metricsChange();
        R.activeMap.populateCuesheet(R.activeMap.activeRoute.coursePoints());
        R.activeMap.drawRouteDistanceMarkers();
      }
      setPreference(prefKey, value);
    };
  });
  settingHandlers.onUnitsChange = (units) => settingHandlers.onMetricUnitsChange(units === "metric");

  const unitsOptions = useMemo(
    () =>
      OrderedMap({
        imperial: fm(commonUnits.imperial),
        metric: fm(commonUnits.metric),
      }),
    [fm]
  );

  return (
    <div className={styles.settingsPosition}>
      <SettingsMenu intl={intl} mapSettings={mapSettings} {...settingHandlers} planner unitsOptions={unitsOptions} />
    </div>
  );
};
